import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_conversation_monthly_usage')
@Index(['year', 'month'], { unique: true })
export class ConversationMonthlyUsageEntity extends BaseEntity {
	// Time Period
	@Column({ type: 'int', unsigned: true })
	public year!: number;

	@Column({ type: 'int', unsigned: true })
	public month!: number; // 1-12

	// Voice Usage (in SECONDS) - INTEGER for precision
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Seconds from current month allocation consumed',
	})
	public currentMonthSeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Seconds carried in from previous month',
	})
	public voiceSecondsCarriedIn!: number;

	// LLM Token Usage - INTEGER for precision (NO ROLLOVER)
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Tokens consumed this month',
	})
	public currentMonthTokens!: number;

	// Metric Split (for analytics)
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice call duration in seconds',
	})
	public voiceSeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Total LLM tokens consumed',
	})
	public llmTokens!: number;

	// Business Days Tracking (for forecasting)
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Mon-Fri',
	})
	public weekdaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Saturday',
	})
	public saturdaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Sunday',
	})
	public sundaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Mon-Fri',
	})
	public weekdayTokens!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Saturday',
	})
	public saturdayTokens!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Sunday',
	})
	public sundayTokens!: number;

	// Activity Stats
	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalVoice!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalChats!: number;

	// Warning System
	@Column({
		type: 'timestamp',
		nullable: true,
		comment: 'Last time warning email was sent (used to enforce 24h limit)',
	})
	public lastWarningEmailSent?: Date;
}
